import React, { useEffect } from 'react';
import { Modal as AntdModal } from 'antd';
import { ModalProps as AntdModalProps } from 'antd/lib/modal';
import { useHistory } from 'react-router-dom';
import { featureEnabled } from 'utils';
import { Color } from '@bb/elements-web-rebranding';

export type ModalProps = AntdModalProps;

export const Modal = (props: ModalProps) => {
  const history = useHistory();

  useEffect(() => {
    if (history) {
      const unlisten = history.listen(() => {
        Modal.destroyAll();
      });

      return () => {
        unlisten();
      };
    }
  }, [history]);
  return (
    <AntdModal
      data-cy="modal-popup"
      {...props}
      okButtonProps={
        featureEnabled('supraRebrandingFeature', 1)
          ? {
              style: {
                backgroundColor: Color.PRIMARY,
                borderColor: Color.PRIMARY,
              },
            }
          : {}
      }
    />
  );
};

Modal.confirm = AntdModal.confirm;
Modal.destroyAll = AntdModal.destroyAll;
Modal.error = AntdModal.error;
Modal.info = AntdModal.info;
Modal.warning = AntdModal.warning;
Modal.warn = AntdModal.warn;
Modal.success = AntdModal.success;

export default Modal;
